module.exports = __webpack_public_path__ + "media/images/application/contact/question-2c45400613cd40dfdeaba319e4dedcd4.svg";